// import { TagQueriesService } from '@/service/tags/tagQueries/tag-queries.service'
import {
  ETypeRecherche,
  GroupePiecesDto,
  PieceClient,
} from '@/shared/services/service-clients'
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms'
import { MatButton, MatButtonModule } from '@angular/material/button'
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatDividerModule } from '@angular/material/divider'
import { MatInputModule } from '@angular/material/input'
import { MatListModule, MatSelectionList } from '@angular/material/list'
import { ScanTagInputComponent } from 'src/app/modules/commons/components/scan-tag-input/scan-tag-input.component'

import { NEVER, Observable, of, Subscription, timer } from 'rxjs'
import {
  catchError,
  debounce,
  filter,
  map,
  startWith,
  switchMap,
  tap,
} from 'rxjs/operators'
import { Tag } from 'src/app/modules/commons/models/tag.model'
import { Filter, FilterType } from 'src/app/modules/search/models/filters.model'
import { MachineState } from '../../models/states.models'
import { TouaregControlStateMachineService } from '../../services/touareg-control-state-machine.service'

@Component({
  selector: 'app-touareg-control-search-dialog',
  templateUrl: './touareg-control-search-dialog.component.html',
  styleUrls: ['./touareg-control-search-dialog.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatDividerModule,
    MatInputModule,
    MatListModule,
    ScanTagInputComponent,
  ],
})
export class TouaregControlSearchDialogComponent implements OnInit, OnDestroy {
  @ViewChild(MatSelectionList) selectionList!: MatSelectionList

  @ViewChild('submitBtn') submitBtn!: MatButton

  private _touaregStatesSubs$!: Subscription

  public byNew: Tag | null = null
  public byPairing: Tag[] = []
  public byUid: GroupePiecesDto[] = []
  public searchCtrl!: UntypedFormControl
  public currentState: MachineState | null | undefined
  public disabled: Record<string | number, boolean> = {}
  public showSearchControlUID!: boolean

  get searchHasValue(): boolean {
    return !!this.searchCtrl.value
  }

  constructor(
    // private _tagQueries: TagQueriesService,
    private _stateMachine: TouaregControlStateMachineService,
    private changeDetector: ChangeDetectorRef,
    public dialogRef: MatDialogRef<TouaregControlSearchDialogComponent>,
    private _pieceClient: PieceClient
  ) {}

  ngOnInit(): void {
    // Le form control nous permet d'écouter un observable
    // Cet observable nous permet d'utiliser les values à chaque changement
    // Et de filtrer les valeurs d'autocompletions
    this.searchCtrl = new UntypedFormControl('')

    this.searchCtrl.valueChanges
      .pipe(
        switchMap((value) => this._getQueryFromParams(value)),
        tap((value) => {})
      )
      .subscribe((data) => {
        // this.byUid = data[0].pieces[0].tagIdentifier
        this.byUid = data

        if (!this.byUid.length && !isNaN(Number(this.searchCtrl.value))) {
          this.byNew = { tag_uid: Number(this.searchCtrl.value) } as any
        } else {
          this.byNew = null
        }

        if (
          ((this.byNew || this.byUid.length === 1) && !this.byPairing.length) ||
          (this.byPairing.length === 1 && !this.byNew && !this.byUid.length)
        ) {
          setTimeout(() => {
            this.selectionList.selectAll()
            if (this.submitBtn) {
              setTimeout(() => this.submitBtn.focus(), 0)
            }
          }, 0)
        } else {
          setTimeout(() => {
            this.selectionList.deselectAll()
          }, 0)
        }
        this.changeDetector.detectChanges()
      })

    // On récupère les tags déjà enregistrés dans la machine a état
    this._touaregStatesSubs$ = this._stateMachine.stateMachine$.subscribe(
      (state) => {
        this.currentState = state
        const disabled: Record<string | number, boolean> = {}
        if (state?.tags_list) {
          for (let tag of state.tags_list) {
            disabled[tag.tag_uid] = true
          }
        }
        this.disabled = disabled
      }
    )
  }

  private _getQueryFromParams(params: string): Observable<GroupePiecesDto[]> {
    // type research taguid = Tag
    let typeResearch = ETypeRecherche.Tag
    let body: string[] = [params]

    return this._pieceClient
      .rechercherPieces(typeResearch, body)
      .pipe(catchError((e) => NEVER))
  }

  private _filterInputValue(value: string): any {
    return !value || value.length < 2 ? null : value
  }

  private _reformatResultValues(result: { byUid: Tag[]; byPairing: Tag[] }): {
    byUid: Tag[]
    byPairing: Tag[]
  } {
    return result
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (!!this._touaregStatesSubs$) this._touaregStatesSubs$.unsubscribe()
  }
}
